import React, { Component } from 'react';
import { connect } from 'shalala';
import * as qs from 'query-string';

import { useStore } from '../../store';
import EmisorRegistration from './upsert/EmisorRegistration';
import PageHeader from '../../support/page-header/PageHeader';
import EmisorSelector from './upsert/components/EmisorSelector';
import EmisorSectorPrimarioProductorRegistration from './upsert/EmisorSectorPrimarioProductorRegistration';
import EmisorSectorPrimarioAdquirienteRegistration from './upsert/EmisorSectorPrimarioAdquirienteRegistration';

class EmisoresRegistration extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: { id },
      edit: { ...data },
      emisor_selector: {},
    };
  }

  handleOnComplete = async (result) => {
    if (!!result) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Registro',
        message: result.message || 'Emisor registrado',
      });

      this._highlightUpsertedItem(result.data);
    }

    const query = qs.parse(this.props.location.search);

    if (!!query.intro) {
      this.props.history.replace('/app/intro');
    } else {
      this.props.history.replace('/app/emisores');
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  _highlightUpsertedItem(data) {
    const { data: emisores } = this.props.list;

    const emisor = {
      ...data,
      highlight: true,
    };

    this.props.setPartialState({ data: [emisor].concat(emisores) });

    setTimeout(() => {
      const emisor = {
        ...data,
        highlight: false,
      };

      this.props.setPartialState({ data: [emisor].concat(emisores) });
    }, 5000);
  }

  handleOnChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      ...this.state,
      [name]: checked,
    });
  };

  handleOnSectorPrimarioChange = (event) => {
    this.setState({ ...this.state, ...event });
  };

  render() {
    const { data, edit } = this.state;

    return (
      <>
        <PageHeader
          text="Emisores"
          to="/app/emisores"
        />

        <h5>
          {!data.id && 'Nuevo'}
          {!!data.id && edit.razon_social}
        </h5>

        <EmisorSelector
          name="emisor_selector"
          value={this.state.emisor_selector}
          onChange={this.handleOnSectorPrimarioChange}
        />

        {Object.keys(this.state.emisor_selector).length === 0 && (
          <EmisorRegistration
            data={data}
            edit={edit}
            onComplete={this.handleOnComplete}
          />
        )}

        {this.state?.emisor_selector?.adquiriente && (
          <EmisorSectorPrimarioAdquirienteRegistration
            data={data}
            edit={edit}
            onComplete={this.handleOnComplete}
          />
        )}

        {this.state?.emisor_selector?.productor && (
          <EmisorSectorPrimarioProductorRegistration
            data={data}
            edit={edit}
            onComplete={this.handleOnComplete}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.emisores.list };
};

const mapActions = (actions) => {
  return actions.app.emisores.list;
};

export default connect(useStore, mapState, mapActions)(EmisoresRegistration);
